import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

const barStyle = {fill: 'var(--header-background)', opacity: 0.85}
const barLabelStyle = {fill: 'var(--p-color)', fontSize: 11}

export default function Observability() {
    return (
        <TopicLayout
            title="Logs, metrics & traces"
            intro="Three complementary signals for understanding a running system: discrete events with full context, aggregated numeric trends, and the path a single request took across services."
            diagram={
                <Diagram viewBox="0 0 560 190">
                    <text x={280} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>One request, three signals</text>
                    <Box x={20} y={30} width={70} height={30} label="Client"/>
                    <Box x={150} y={30} width={70} height={30} label="A" accent/>
                    <Box x={280} y={30} width={70} height={30} label="B" accent/>
                    <Box x={410} y={30} width={70} height={30} label="C" accent/>
                    <Arrow x1={90} y1={45} x2={150} y2={45}/>
                    <Arrow x1={220} y1={45} x2={280} y2={45}/>
                    <Arrow x1={350} y1={45} x2={410} y2={45}/>

                    <text x={135} y={104} textAnchor="end" style={barLabelStyle}>span A</text>
                    <rect x={150} y={94} width={330} height={16} rx={3} style={barStyle}/>
                    <text x={185} y={126} textAnchor="end" style={barLabelStyle}>span B</text>
                    <rect x={200} y={116} width={240} height={16} rx={3} style={{...barStyle, opacity: 0.65}}/>
                    <text x={235} y={148} textAnchor="end" style={barLabelStyle}>span C</text>
                    <rect x={250} y={138} width={120} height={16} rx={3} style={{...barStyle, opacity: 0.45}}/>

                    <text x={280} y={175} textAnchor="middle" fontSize={11} opacity={0.7}>trace: this waterfall — logs: what happened at each step — metrics: aggregated rates and latencies</text>
                </Diagram>
            }
            useWhen={[
                'Logs: you need the full context of one specific event, such as debugging why a particular request failed.',
                'Metrics: you need cheap, aggregated trends over time to alert on and dashboard, such as error rate or p99 latency.',
                'Traces: you need to see where time went across service boundaries for a single request, especially in a system with many hops.'
            ]}
            tradeOff="Logs are the richest signal but the most expensive to store and search at volume, and they say nothing about trends unless aggregated after the fact. Metrics are cheap to collect and alert on but lose per-request detail — a metric can tell you latency degraded, not which request or why. Traces show causality across services but require every hop to propagate context and add instrumentation overhead. None of the three replaces the others; alerting typically starts on metrics, root-causing moves to traces, and confirming the exact cause ends in logs."
            ruleOfThumb="Instrument all three from the start rather than retrofitting later: metrics for alerting, traces for cross-service latency, and structured logs correlated by a trace ID for the detailed 'why'."
        />
    )
}
